module.exports = __webpack_public_path__ + "img/icon-plus-zwart.54bf27275cf2aedaf08da8bfd7f315d5.svg";